export const theoreticalConfig = {
  title: "Calculated Consumption Data",
  storageKey: "theoreticalDates",
  excelConfig: {
    getHeaders: (data, reportType, capitalizeWords) => {
      if (reportType === "daily") {
        return [
          "Branch Name", "Branch Code", "City", "State", "Country",
          "Item Name", "Item Code", "Unit", "Quantity"
        ];
      }

      return Object.keys(data[0]).map(capitalizeWords);
    },

    mapRow: (item, reportType, formatValue) => {
      if (reportType === "daily") {
        return [
          item.branch_name,
          item.branch_code,
          item.city,
          item.state,
          item.country,
          item.item_name,
          item.item_code,
          item.unit,
          formatValue(item.total_quantity),
        ];
      }

      return Object.values(item).map(val =>
        typeof val === "string" && val.startsWith("'")
          ? parseFloat(val.slice(1))
          : formatValue(val)
      );
    }
  },
  apiPayloadBuilder: ({ start_date, end_date, outlets }) => ({
    start_date,
    end_date,
    consumptionType: "Theoretical",
    outlets
  }),
};